import React from 'react'

import { useLocation } from 'react-router'

import { SystemSpaceSlug, useSpaceUtil } from '@tribeplatform/react-sdk/hooks'

import { useCurrentPage } from '../../hooks/useCurrentPage'
import { NotificationSettingsLink } from '../Notification/controls/NotificationSettingsLink'
import { NotificationsMarkAsRead } from '../Notification/controls/NotificationsMarkAsRead'

export const useMobileNavbar = () => {
  const { matchPath, hasViewPermission } = useSpaceUtil()
  const location = useLocation()

  const { data: page } = useCurrentPage({
    useQueryOptions: {
      retry: 0,
    },
  })

  let title
  let pageOverrideControls

  if (matchPath(SystemSpaceSlug.NOTIFICATIONS, location.pathname)) {
    title = page?.space?.name
    if (hasViewPermission(SystemSpaceSlug.NOTIFICATIONS)) {
      pageOverrideControls = (
        <>
          <NotificationsMarkAsRead />
          <NotificationSettingsLink />
        </>
      )
    }
  }

  return {
    title,
    controls: pageOverrideControls,
  }
}
